// extracted by mini-css-extract-plugin
export default {"content":"ModalPacksMesFicha_content__YvULV","card":"ModalPacksMesFicha_card__G2mSh","info":"ModalPacksMesFicha_info__m9UCy"};